import {NotificationService} from "../../services/NotificationService";
import {Asset} from "../../entities/Asset";
import {CustomFieldNameService} from "../../services/CustomFieldNameService";
import {AssetService} from "../../services/AssetService";
import {PagingModel} from "../paging/PagingModel";

export class PickChildModel extends PagingModel<Asset> {
    static $inject = ['$q','AssetService','CustomFieldNameService','NotificationService'];
    selectedAsset:Asset;
    selectedAssets:Asset[] = [];
    errorMessage:string = "";
    parentAsset:Asset;
    constructor($q:ng.IQService,
                public pagingService:AssetService,
                public customFieldNameService:CustomFieldNameService,
                public notifyService:NotificationService) {
      super($q, pagingService, notifyService);
    }
    init(parentAsset:Asset){
      this.parentAsset = parentAsset;
    }
    entityName():string{
      return "asset";
    }
    displayName():string{
      return "Assets";
    }
    selectionChanged():void{
      this.selectedAssets = [];
      for(var i=0;i<this.selectedItems.length;i++){
        this.selectedAssets.push(this.selectedItems[i]);
      }
      if(this.selectedItems.length > 0)
        this.selectedAsset = this.selectedItems[0];
      else
        this.selectedAsset = null;
    }
    getPagedPromise():ng.IPromise<any>{
      if(this.parentAsset == null)
        return this.$q.when<Asset[]>([]);
      else
        return this.pagingService.getPagedUsableChildren(this.parentAsset.id,this.search,this.page,this.pageSize,this.orderColumn,this.orderDirection);
    }
    getCountPromise():ng.IPromise<any>{
      if(this.parentAsset == null)
        return this.$q.when<number>(0);
      else
        return this.pagingService.getCountUsableChildren(this.parentAsset.id,this.search);
    }
    getColumnDefs():ng.IPromise<void>{
      return this.customFieldNameService.getAssetColumnDefs().then((data)=>{
        this.nameValuePairs = data;
      });
    }
  }
